import React from 'react'

import { Form } from '_zari/core'

import * as UsuarioCrud from 'services/usuario.service'

const UsuarioFormGroup = ({ oneRowTrigger, ...props }) => {
  const [listaUsuarios, setListaUsuarios] = React.useState([])

  React.useEffect(() => {
    UsuarioCrud.obtenerTodoAsSelect()
      .then(({ data }) => {
        setListaUsuarios(data)
        if (data && data.length === 1) {
          oneRowTrigger(data[0])
        }
      })
      .catch(() => setListaUsuarios([]))
  }, [oneRowTrigger])

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {listaUsuarios.map((x, k) => (
        <option key={k} value={x._id}>
          {x.apellidos}, {x.nombres} ({x.username})
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(UsuarioFormGroup)
